/* FANGZ PDP — interactivity for fangz-product-page section.
   Each section instance is initialised independently via data-fz-pdp. */
(function () {
  'use strict';

  function moneyFormat(cents, format) {
    if (typeof cents !== 'number') cents = parseFloat(cents);
    if (isNaN(cents)) return '';
    var dollars = (cents / 100).toFixed(2);
    if (!format) return '$' + dollars;
    return format.replace(/\{\{\s*amount\s*\}\}/, dollars).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function qtyHint(q) {
    // Pack buttons drive quantity now; this is retained only for safety if a
    // qty-hint element is ever re-added. Tiers: 5+ chews = 15% off (matches
    // the "15% off 5+ chews" Shopify automatic discount). 3 = minimum order.
    if (q >= 5) return 'Saving 15%, best value';
    if (q >= 3) return '3-chew minimum met';
    return 'Single chew';
  }

  function init(root) {
    if (!root || root.__fzPdpInit) return;
    root.__fzPdpInit = true;

    var moneyFmt = root.getAttribute('data-money-format') || '${{amount}}';
    var variantsRaw = root.getAttribute('data-variants') || '[]';
    var sizeMap = {};
    try { sizeMap = JSON.parse(variantsRaw); } catch (e) { sizeMap = {}; }

    var sizeChips = root.querySelectorAll('[data-size-chip]');
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus = root.querySelector('[data-qty-plus]');
    var qtyVal = root.querySelector('[data-qty-val]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var qtyHintEl = root.querySelector('[data-qty-hint]');
    var subToggle = root.querySelector('[data-subsave-toggle]');
    var subTitle = root.querySelector('[data-subsave-title]');
    var subSub = root.querySelector('[data-subsave-sub]');
    var subInput = root.querySelector('[data-subsave-input]');
    var atcBtn = root.querySelector('[data-atc]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var atcTotal = root.querySelector('[data-atc-total]');
    var atcSticky = root.querySelector('.atc-sticky');
    var pinfo = root.querySelector('.pinfo');
    var phead = root.querySelector('.phead');
    var priceLine = root.querySelector('[data-price]');
    var priceMeta = root.querySelector('[data-price-meta]');
    var variantInput = root.querySelector('[data-variant-input]');
    var tabs = root.querySelectorAll('[data-tab]');

    var state = {
      size: root.getAttribute('data-default-size') || 'medium',
      qty: 1,
      subSave: false
    };

    function currentVariant() {
      return sizeMap[state.size] || null;
    }

    var stickyPin = {
      enabled: false,
      metrics: null,
      measureRaf: 0,
      applyRaf: 0,
      mode: 'flow'
    };

    function clearPinnedInfo() {
      if (!pinfo) return;
      pinfo.classList.remove('is-pinned-js');
      pinfo.style.position = '';
      pinfo.style.left = '';
      pinfo.style.top = '';
      pinfo.style.bottom = '';
      pinfo.style.width = '';
      stickyPin.mode = 'flow';
    }

    function shouldUsePinnedInfo() {
      if (!root.classList.contains('is-spirulina-sticky')) return false;
      if (!pinfo || !phead) return false;
      if (pinfo.classList.contains('no-sticky')) return false;
      if (window.matchMedia && !window.matchMedia('(min-width: 901px)').matches) return false;
      return true;
    }

    function applyPinnedInfo() {
      stickyPin.applyRaf = 0;
      if (!stickyPin.enabled || !stickyPin.metrics) {
        clearPinnedInfo();
        return;
      }

      var m = stickyPin.metrics;
      var scrollY = window.scrollY || window.pageYOffset || 0;
      var startY = m.naturalTop - m.stickyTop;
      var endY = m.sectionBottom - (m.stickyTop + m.height);

      if (scrollY < startY) {
        clearPinnedInfo();
        return;
      }

      var releaseOffset = scrollY > endY ? (scrollY - endY) : 0;
      var currentTop = m.stickyTop - releaseOffset;

      pinfo.classList.add('is-pinned-js');
      pinfo.style.position = 'fixed';
      pinfo.style.left = m.left + 'px';
      pinfo.style.width = m.width + 'px';
      pinfo.style.top = currentTop + 'px';
      pinfo.style.bottom = 'auto';
      stickyPin.mode = releaseOffset > 0 ? 'release' : 'pinned';
    }

    function measurePinnedInfo() {
      stickyPin.measureRaf = 0;

      if (!shouldUsePinnedInfo()) {
        stickyPin.enabled = false;
        stickyPin.metrics = null;
        clearPinnedInfo();
        return;
      }

      stickyPin.enabled = true;

      if (stickyPin.mode !== 'flow') clearPinnedInfo();

      var scrollY = window.scrollY || window.pageYOffset || 0;
      var pinfoRect = pinfo.getBoundingClientRect();
      var pheadRect = phead.getBoundingClientRect();
      var gap = 24;
      var stickyTop = window.innerHeight - pinfoRect.height - gap;

      stickyPin.metrics = {
        naturalTop: pinfoRect.top + scrollY,
        sectionBottom: pheadRect.bottom + scrollY,
        height: pinfoRect.height,
        width: pinfoRect.width,
        left: pinfoRect.left,
        stickyTop: stickyTop
      };

      applyPinnedInfo();
    }

    function schedulePinnedInfoMeasure() {
      if (stickyPin.measureRaf) return;
      if (window.requestAnimationFrame) {
        stickyPin.measureRaf = window.requestAnimationFrame(measurePinnedInfo);
      } else {
        stickyPin.measureRaf = setTimeout(measurePinnedInfo, 16);
      }
    }

    function schedulePinnedInfoApply() {
      if (stickyPin.applyRaf) return;
      if (window.requestAnimationFrame) {
        stickyPin.applyRaf = window.requestAnimationFrame(applyPinnedInfo);
      } else {
        stickyPin.applyRaf = setTimeout(applyPinnedInfo, 16);
      }
    }

    function recompute() {
      var v = currentVariant();
      if (!v) return;
      var basePrice = v.price; // cents
      var unit = basePrice;
      // Headline price shows the single-chew price for the selected size.
      // Quantity discounts are surfaced on the pack buttons (see fangz-pack.js).
      var total = unit * state.qty;
      if (state.subSave) total = total * 0.85;
      total = Math.round(total);

      if (priceLine) priceLine.textContent = moneyFormat(total, moneyFmt);
      if (priceMeta) {
        priceMeta.textContent = (v.weight || '') + ' · ' + (v.range || '') + ' · per chew' + (state.subSave ? ' · sub' : '');
      }
      if (atcTotal) atcTotal.textContent = moneyFormat(total, moneyFmt);
      if (qtyHintEl) qtyHintEl.textContent = qtyHint(state.qty);
      if (qtyVal) qtyVal.textContent = state.qty;
      if (qtyInput) qtyInput.value = state.qty;
      if (qtyMinus) qtyMinus.disabled = state.qty <= 1;
      if (variantInput) variantInput.value = v.id || '';
      if (atcBtn) atcBtn.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
    }

    var stickyMetricsRaf = 0;
    function syncStickyMetrics() {
      stickyMetricsRaf = 0;

      if (atcSticky) {
        var atcHeight = Math.ceil(atcSticky.getBoundingClientRect().height || 0);
        if (atcHeight > 0) root.style.setProperty('--fz-atc-sticky-height', atcHeight + 'px');
      }

      if (pinfo && root.classList.contains('is-spirulina-sticky')) {
        var pinfoHeight = Math.ceil(pinfo.getBoundingClientRect().height || 0);
        if (pinfoHeight > 0) root.style.setProperty('--fz-pinfo-sticky-height', pinfoHeight + 'px');
      }

      schedulePinnedInfoMeasure();
    }
    function scheduleStickyMetricsSync() {
      if (stickyMetricsRaf) return;
      if (window.requestAnimationFrame) {
        stickyMetricsRaf = window.requestAnimationFrame(syncStickyMetrics);
      } else {
        stickyMetricsRaf = setTimeout(syncStickyMetrics, 16);
      }
    }

    sizeChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var size = chip.getAttribute('data-size-chip');
        if (!size) return;
        var v = sizeMap[size];
        if (!v || !v.available) return;
        state.size = size;
        sizeChips.forEach(function (c) { c.classList.toggle('active', c === chip); });
        recompute();
        scheduleStickyMetricsSync();
      });
    });

    if (qtyMinus) qtyMinus.addEventListener('click', function () {
      if (state.qty > 1) { state.qty -= 1; recompute(); scheduleStickyMetricsSync(); }
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function () {
      if (state.qty < 12) { state.qty += 1; recompute(); scheduleStickyMetricsSync(); }
    });

    if (subToggle) subToggle.addEventListener('click', function () {
      state.subSave = !state.subSave;
      subToggle.classList.toggle('on', state.subSave);
      subToggle.setAttribute('aria-checked', state.subSave ? 'true' : 'false');
      if (subTitle) subTitle.textContent = state.subSave ? 'Subscribe & save 15%' : 'Buy once';
      if (subSub) subSub.textContent = state.subSave
        ? 'Every 4 weeks. Skip or cancel anytime.'
        : 'Tap to switch — every 4 weeks, save 15%.';
      if (subInput) subInput.value = state.subSave ? 'true' : 'false';
      recompute();
      scheduleStickyMetricsSync();
    });

    tabs.forEach(function (t) {
      var head = t.querySelector('[data-tab-head]');
      if (!head) return;
      head.addEventListener('click', function () {
        var open = t.classList.contains('open');
        // close all siblings, then optionally re-open this one
        tabs.forEach(function (x) { x.classList.remove('open'); });
        if (!open) t.classList.add('open');
      });
    });

    // initial mark of active size chip
    sizeChips.forEach(function (c) {
      c.classList.toggle('active', c.getAttribute('data-size-chip') === state.size);
    });

    setupGalleryThumbs(root);

    recompute();
    scheduleStickyMetricsSync();
    schedulePinnedInfoMeasure();
    window.addEventListener('load', scheduleStickyMetricsSync, { once: true });
    window.addEventListener('resize', scheduleStickyMetricsSync);
    window.addEventListener('scroll', schedulePinnedInfoApply, { passive: true });
    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(scheduleStickyMetricsSync);
      if (atcSticky) ro.observe(atcSticky);
      if (pinfo) ro.observe(pinfo);
    }
  }

  function setupGalleryThumbs(root) {
    var gallery = root.querySelector('.gallery');
    if (!gallery || gallery.__fzThumbsInit) return;
    var frames = Array.prototype.slice.call(gallery.children).filter(function (n) {
      return n.classList && n.classList.contains('frame');
    });
    if (frames.length < 2) return;
    gallery.__fzThumbsInit = true;

    var thumbs = document.createElement('div');
    thumbs.className = 'fz-pdp-thumbs';
    thumbs.setAttribute('role', 'tablist');
    var buttons = [];
    frames.forEach(function (frame, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fz-pdp-thumb';
      btn.setAttribute('aria-label', 'View image ' + (i + 1));
      var img = frame.querySelector('img');
      if (img && img.getAttribute('src')) {
        var thumbImg = document.createElement('img');
        thumbImg.src = img.getAttribute('src');
        thumbImg.alt = '';
        thumbImg.loading = 'lazy';
        btn.appendChild(thumbImg);
      } else {
        btn.classList.add('fz-pdp-thumb--placeholder');
      }
      if (i === 0) btn.classList.add('is-active');
      btn.addEventListener('click', function () {
        var x = frame.offsetLeft - gallery.offsetLeft;
        if (gallery.scrollTo) gallery.scrollTo({ left: x, behavior: 'smooth' });
        else gallery.scrollLeft = x;
      });
      thumbs.appendChild(btn);
      buttons.push(btn);
    });
    gallery.parentNode.insertBefore(thumbs, gallery.nextSibling);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.5) {
            var idx = frames.indexOf(e.target);
            if (idx > -1) {
              buttons.forEach(function (b, i) { b.classList.toggle('is-active', i === idx); });
            }
          }
        });
      }, { root: gallery, threshold: 0.5 });
      frames.forEach(function (f) { io.observe(f); });
    }
  }

  function boot() {
    document.querySelectorAll('[data-fz-pdp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-fz-pdp]');
    if (root) init(root);
  });
})();
